import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import AppContext from "../../context/AppContext";
import { toast } from "react-toastify";
import {
  updateProfileInfo,
  getUserInfo,
  updateProfilePicture,
} from "../../service/User";
import dummyImg from "../../assets/dummy.webp";
import { deleteS3Object, uploadFileToS3 } from "../../service/S3Bucket";
import { Spinner } from "../../Spinner";
import translations from "../../components/common/Translations";
import { FaArrowLeft, FaEye, FaEyeSlash } from "react-icons/fa";

const ProfileSection = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { profilePic, setProfilePic, langMode } = useContext(AppContext);
  const [userInfo, setUserInfo] = useState(null);
  const [initialUserInfo, setInitialUserInfo] = useState(null);
  const { theme } = useContext(AppContext);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isPasswordCleared, setIsPasswordCleared] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('')
  const [selectedFile, setSelectedFile] = useState('')
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  useEffect(() => {
    const profilePic = Cookies.get("profilePic");
    if (profilePic && profilePic !== "null") {
      setProfilePic(profilePic);
    } else {
      setProfilePic(dummyImg);
    }
  }, []);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  async function deleteExistingImage() {
    const oldPic = Cookies.get("profilePic");
    if (!oldPic || oldPic === "null") return; // No image to delete

    try {
      const urlParts = oldPic.split('/');
      const oldKey = urlParts.slice(3).join('/'); // Extracts key from S3 URL
      console.log("Deleting S3 object with key:", oldKey);

      await deleteS3Object({ Key: oldKey }); // Pass as object with Key property
    } catch (error) {
      console.error("Error deleting existing S3 image:", error);
    }
  }

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];

    if (!file || !allowedTypes.includes(file.type)) {
      toast.error("Invalid file type. Please upload a JPG, PNG, or GIF.");
      return;
    }
    setUploadedImg(URL.createObjectURL(file));
    setSelectedFile(file); // Store file for later upload
  };

  const navigate = useNavigate();
  const ChangePassword = () => {
    if (userInfo?.email) {
      navigate("/reset-password", {
        state: { emaill: userInfo.email, fromProfile: true },
      });
    } else {
      toast.error("Email not available. Please ensure your profile is loaded.");
    }
  };
  useEffect(() => {
    GetUserInfo();
  }, []);

  const GetUserInfo = async () => {
    setLoading(true);
    try {
      const data = await getUserInfo();
      setUserInfo(data);
      setInitialUserInfo(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // const handleFieldChange = (e) => {
  //   const { name, value } = e.target;
  //   setUserInfo((prevUserInfo) => ({
  //     ...prevUserInfo,
  //     [name]: value,
  //   }));
  // };

  const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const handleFieldChange = (e) => {
    if (!userInfo) return;

    const { name, value } = e.target;

    if (name === "password") {
      if (!isPasswordCleared && value !== "") {
        toast.error("You cannot modify the existing password unless cleared first.");
        return;
      }

      if (!isPasswordCleared && value === "") {
        toast.success("You can now enter a new password.");
        setIsPasswordCleared(true);
        setUserInfo((prevUserInfo) => ({
          ...prevUserInfo,
          password: "",
        }));
        return;
      }


    }

    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      [name]: value,
    }));
  };


  const handleCancle = () => {
    const path = Cookies.get('previousPath')
    navigate(path);
  };

  const handleSaveChanges = async () => {
    if (selectedFile) {
      const uploadedPhotoUrl = await uploadFileToS3(selectedFile);
      if (!uploadedPhotoUrl) {
        throw new Error("Upload failed or returned empty URL");
      }
      setProfilePic(uploadedPhotoUrl);
      await updateProfilePicture(uploadedPhotoUrl);
    }

    if (isPasswordCleared && !validatePassword(userInfo.password)) {
      toast.error("Password must be at least 8 characters, include an uppercase letter, lowercase letter, number, and special character.");
      return
    }
    try {
      await updateProfileInfo(
        userInfo.userId,
        userInfo.name,
        userInfo.email,
        userInfo.phone,
        userInfo.password,
        isPasswordCleared,
      );
      sessionStorage.setItem("userDetails", JSON.stringify(userInfo));
      Cookies.set("userType", userInfo.userType, {
        secure: true,
        sameSite: "strict",
      });
      Cookies.set("userId", userInfo.userId);
      Cookies.set("userName", userInfo.name);
      Cookies.set("userVisibility", userInfo.userVisibility);
      Cookies.set("userEmail", userInfo.email, { httpOnly: true });
      GetUserInfo();
      toast.success("Profile Updated");
    } catch (error) { }
  };

  const handleGoBack = () => {
    const path = Cookies.get('previousPath')
    navigate(path);
  };
  return (
    <div className="w-full">
      {loading && <Spinner />}
      <div className="inline-flex gap-3 mt-2">
        {" "}
        <div
          onClick={handleGoBack}
          className={` p-2 rounded-full border cursor-pointer w-8 
${theme === "dark" ? "bg-gray-800 border-gray-600 hover:bg-gray-700" : ""} 
${theme === "high-contrast" ? "high-contrast border border-gray-600 " : ""} 
${theme !== "dark" && theme !== "high-contrast"
              ? "border-gray-400 hover:bg-gray-200"
              : ""
            }`}
        >
          <FaArrowLeft
            className={`h-3 w-3 ${theme === "dark"
              ? "text-white"
              : theme === "high-contrast"
                ? "text-black"
                : "text-gray-700"
              }`}
          />
        </div>
        <h4
          className={` ${theme === "dark"
            ? "dark-mode "
            : theme === "high-contrast"
              ? "high-contrast  "
              : ""
            } text-sm uppercase font-semibold text-gray-800 mt-1`}
        >
          {translations[langMode].profile}
        </h4>
      </div>
      <div
        className={`px-5 py-5 mt-2 bg-white ${theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          } `}
      >
        <div className="w-1/2">
          <div className="mb-5">
            <img
              key={profilePic}
              className={`w-20 h-20 p-1 rounded-full border-2 border-gray-400 my-2 ml-2 ${theme === "dark"
                ? "bg-white"
                : theme === "high-contrast"
                  ? "bg-white"
                  : ""
                }`}
              src={uploadedImg ? uploadedImg : profilePic}
              alt="profileimg"
            />
            <span
              className="text-sm text-blue-700 font-semibold underline cursor-pointer"
              onClick={triggerFileInput}
            >
              <p className="">Change Profile</p>
            </span>
            <input
              type="file"
              name="media"
              onChange={handleImageUpload}
              accept="image/jpeg, image/png, image/gif, image/jpg"
              className="uploadFile hidden"
              ref={fileInputRef}
            />
          </div>
          <h3 className="text-sm text-gray-500 font-bold">Basic Info</h3>
          <div className=" mt-5 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-4">
            <div className="sm:col-span-2">
              <div className="relative">
                <input
                  type="text"
                  value={userInfo && userInfo.name}
                  onChange={handleFieldChange}
                  name="name"
                  className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 
                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode "
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
                <label
                  className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                >
                  {translations[langMode].username}
                </label>
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <input
                  type="text"
                  value={userInfo && userInfo.userType}
                  name="userType"
                  className={`block read-only cursor-none px-2.5 pb-2.5 pt-4 w-full text-sm bg-gray-300 text-gray-900 rounded-md border-2 
                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
                <label
                  className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                >
                  {translations[langMode].userType}
                </label>
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <input
                  type="text"
                  value={userInfo && userInfo.email}
                  onChange={handleFieldChange}
                  name="email"
                  className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 
                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
                <label
                  className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                >
                  {translations[langMode].Email}
                </label>
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <input
                  type="text"
                  value={userInfo && userInfo.phone}
                  onChange={handleFieldChange}
                  name="phone"
                  className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 
                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
                <label
                  className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                >
                  {translations[langMode].Phone}
                </label>
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <input
                  type="text"
                  value={userInfo && userInfo.userId}
                  name="userId"
                  className={`block read-only px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 
                    appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 cursor-none peer ${theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                />
                <label
                  className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                    }`}
                >
                  userId
                </label>
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={userInfo && userInfo?.password}
                  onChange={handleFieldChange}
                  name="password"

                  className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-md border-2 
      appearance-none focus:outline-none focus:ring-0 focus:border-gray-500 peer ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""
                    }`}
                />
                <label
                  className={`absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-8 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-700 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""
                    }`}
                >
                  {translations[langMode].password}
                </label>
                <button
                  type="button"
                  disabled={!isPasswordCleared}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-600"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
                {/* <span
                  onClick={ChangePassword}
                  className="float-right text-sm text-blue-700 font-semibold underline cursor-pointer"
                >
                  Change Password
                </span> */}
              </div>


              {/* <span
                onClick={ChangePassword}
                className="float-right text-sm text-blue-700 font-semibold underline cursor-pointer"
              >
                Change Password
              </span> */}
            </div>
          </div>
        </div>
        <div className="mt-10">
          <div className="sm:col-span-4">
            <hr className="w-full border-gray-300" />
          </div>
          <div className="sm:col-span-4 pt-5 flex justify-end items-center">
            <button
              type="button"
              onClick={handleCancle}
              className="px-3 py-2 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
            >
              {translations[langMode].cancel}
            </button>
            <button
              type="button"
              onClick={handleSaveChanges}
              className="px-3 py-2 text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            >
              {translations[langMode].save}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfileSection;
